import {createAction, props} from '@ngrx/store';
import {SynchronizationConfiguration, SynchronizationTaskHistory} from './synchronization.reducer';

export const loadSynchronizationConfigurations = createAction(
  '[Synchronization] Load synchronization configurations'
);
export const loadTaskHistory = createAction(
  '[Synchronization] Load synchronization task history',
  props<{ configId: string }>()
);
export const scheduleSynchronization = createAction(
  '[Synchronization] Schedule synchronization',
  props<{ configId: string }>()
);
export const createSynchronizationConfiguration = createAction(
  '[Synchronization] Create synchronization configuration',
  props<{ body: Partial<SynchronizationConfiguration> }>()
);

export const loadSynchronizationsSuccess = createAction(
  '[Synchronization] Load synchronization configurations success',
  props<{ configs: SynchronizationConfiguration[] }>()
);
export const loadTaskHistorySuccess = createAction(
  '[Synchronization] Load task histories success',
  props<{ histories: SynchronizationTaskHistory[], configId: string }>()
);
export const synchronizationConfigurationCreated = createAction(
  '[Synchronization] Synchronization configuration created'
);
